import { render, staticRenderFns } from "./Diagnosed.vue?vue&type=template&id=3338fd64&scoped=true&lang=pug"
import script from "./Diagnosed.vue?vue&type=script&lang=js"
export * from "./Diagnosed.vue?vue&type=script&lang=js"
import style0 from "./Diagnosed.vue?vue&type=style&index=0&id=3338fd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338fd64",
  null
  
)

export default component.exports